export const paths = {
  any: '*',
  root: '/',
  dashboard: '/dashboard',
  documents: {
    root: '/documents',
    any: '/documents/*',
    preview: '/documents/preview/:documentId',
    document: '/documents/document/:documentId',
  },
  login: '/login',
  redirect: '/redirect',
  savings: '/savings',
  services: {
    root: '/services',
    tab: '/services/:tab',
  },
  locations: '/locations',
  upcomingEvents: '/upcoming-events',
  chat: '/chat',
  teamMembers: {
    root: '/team-members',
    tab: '/team-members/:tab',
  },
  account: '/account',
  billing: {
    root: '/billing',
    tab: '/billing/:tab',
  },
  vendors: {
    root: '/vendors',
    tab: '/vendors/:tab',
  },
  about: '/about',
  reports: {
    root: '/reports',
    tab: '/reports/:reportId',
  },
  subsidiaryOrganization: '/subsidiary-organization',
  tickets: {
    employee: {
      root: '/:orgId/tickets',
      tab: '/:orgId/tickets/:tab',
      new: '/:orgId/tickets/new',
      details: '/:orgId/tickets/:tab/:ticketId',
      detailsWithTab: '/:orgId/tickets/:tab/:ticketId/:detailsTab',
      children: {
        tab: ':tab',
        new: 'new',
        details: ':tab/:ticketId',
        detailsWithTab: ':tab/:ticketId/:detailsTab',
      },
    },
    client: {
      root: '/tickets',
      tab: '/tickets/:tab',
      new: '/tickets/new',
      details: '/tickets/:tab/:ticketId',
      detailsWithTab: '/tickets/:tab/:ticketId/:detailsTab',
      children: {
        tab: ':tab',
        new: 'new',
        details: ':tab/:ticketId',
        detailsWithTab: ':tab/:ticketId/:detailsTab',
      },
    },
  },
  help: '/help',
  billPay: '/bill-pay',
  contractTerms: '/contract-terms',
  notFound: '/not-found',
} as const;
